module.exports = __webpack_public_path__ + "0fba946fea4113b499fcd87ddcdddfa9.woff";